<template>
  <div>
    <button class="btn green margin-bottom-10" @click="showAddFormModal = true">Add New</button>
    <base-form-index
      v-if="!loading"
      :loading="loading"
      :rows="rows"
      :columns="columns"
      @form-removed="fetchOrganizationForms"
    />

    <add-form-modal v-if="showAddFormModal"
                    v-on:hide="showAddFormModal = false"
                    :modules="modules"
                    :userAccessLevels="accessLevels"/>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import BaseFormIndex from "./BaseFormIndex";
import AddFormModal from "@/components/formbuilder/modals/AddFormModal";

export default {

  components: {
    AddFormModal,
    BaseFormIndex,
  },

  data() {
    return {
      showAddFormModal: false,
      formPublish: true,
      formAccounts: [],
      columns: [
        {
          label: 'Related To',
          field: 'module_name',
          filterOptions: {enabled: true}
        },
        {
          label: 'Name',
          field: 'name',
          html: true,
          filterOptions: {enabled: true}
        },
        {
          label: 'Description',
          field: 'description',
          filterOptions: {enabled: true}
        },
        {
          label: 'Status',
          field: 'publish',
          filterOptions: {enabled: true}
        },
        {
          label: 'Created By',
          field: 'created_date',
          filterOptions: {enabled: true}
        },
        {
          label: 'Last Modified',
          field: 'last_modification_date',
          filterOptions: {enabled: true}
        },
        {
          label: 'Actions',
          field: 'actions',
          sortable: false,
        }
      ],
      accessLevels: [
        {
          'name': 'Case Manager',
          'key': 'CASE_MANAGER',
        },
        {
          'name': 'Supervisor',
          'key': 'SUPERVISOR',
        },
        {
          'name': 'Program Administrator',
          'key': 'PROGRAM_ADMINISTRATOR'
        }
      ],
    }
  },

  computed: {
    ...mapGetters({
      loading: 'getOrganizationFormsLoading',
      forms: 'getOrganizationForms',
      modules: 'getOrganizationFormsModules'
    }),

    rows() {
      let rows = [];
      Object.entries(this.forms).forEach(([key, row]) => {

        let date = this.$options.filters.formatDate(row.created_date.date);
        row.created_date = row.user + ' on ' + date;

        if (row.last_modification_date) {
          date = this.$options.filters.formatDate(row.last_modification_date);
        }

        if (row.last_action_user) {
          row.last_modification_date = row.last_action_user + ' on ' + date;
        }
        rows.push(row);
      });
      return rows;
    }
  },

  mounted() {
    this.fetchOrganizationForms();
  },

  methods: {
    ...mapActions([
      'fetchOrganizationForms'
    ]),
  },
}
</script>



// WEBPACK FOOTER //
// OrganizationFormsIndex.vue?159914f7